<template lang="pug">
div
  v-card.my-8.mx-0 
    v-card-title.car-header(
      center,
      v-bind:class="{ orange: car.Recommended == 0 }"
    ) {{ car.Name }} {{ car.Price }}
    h5.ml-2.pt-2.center Based on your driving, you could be saving about*
    div.text-h3.savings {{ runningCostsSavings }}
    p.small in annual running costs
    p.savings +
    div.text-h3.savings {{ co2Savings }} kg
    p.small of CO₂ emmissions each year
    br
    p.details.small {{ runningCostDetails }}
    p.details.small {{ co2SavingsDetails }}
    v-chip.ma-2(v-if="car.Unsuitable", label, color="cyan", text-color="white") 
      v-icon(left) mdi-alert-octagon
      span Check with your this.$dealer if this car suits your driving needs
  v-card
    v-card-title Savings breakdown {{ savingsModeLabel }}
    v-simple-table.mx-4(
      :items="savingDetails",
      :headers="headers",
      hide-default-header,
      hide-default-footer,
      dense
    )
      template(v-slot:default)
        thead
          tr
            th
            th
            th
        tbody
          tr(v-for="item in savingDetails", :key="item.name")
            td {{ item.name }}
            td {{ item.label }}
            td {{ item.savings }}
    v-card-text.disclaimer *This estimate uses map data, like hills, road layout, and driving speeds with cost and efficiency estimates that you can see in the settings below.
</template>

<script>
import ContactForm from "./ContactForm";

export default {
  props: ["carList", "selectedIndex", "trips", "bubble"],
  data() {
    return {
      name: "CarDetails",
      dialog: false,
      co2Data: [
        { Name: "Kauri", PerTree: 1031 },
        { Name: "Totara", PerTree: 593 },
        { Name: "Kahikatea", PerTree: 102 },
        { Name: "Puriri", PerTree: 1779 },
        { Name: "Red Beech", PerTree: 127 },
        { Name: "Black Beech", PerTree: 65 },
        { Name: "Pohutukawa", PerTree: 385 },
        { Name: "Rata", PerTree: 147 },
      ],
      treeIndex: Math.floor(Math.random() * 8),
      selected: false,
      headers: [
        { text: "", align: "start", value: "name" },
        { text: "", align: "center", value: "label" },
        { text: "", align: "end", value: "savings" },
      ],
    };
  },
  computed: {
    savingsModeLabel() {
      switch (this.bubble.savingsMode) {
        case "home":
          return "Weekly Driving";
        case "trips":
          return "Trips";
        case "both":
          return "Both Trips and Weekly Driving";
      }
      return "";
    },
    car() {
      return this.carList[this.selectedIndex];
    },
    selectCar() {
      if (this.selected) {
        return this.carList[this.selectedIndex];
      }
      return null;
    },
    price() {
      return "$" + this.formatPrice(this.car.Price);
    },
    runningCosts() {
      return "$" + this.formatPrice(this.car.RunningCosts);
    },
    runningCostDetails() {
      return (
        "Over 5 years you could pay $" +
        this.formatPrice(this.car.PetrolEquivilent * 5) +
        " to run a petrol car, or $" +
        this.formatPrice(this.car.RunningCosts * 5) +
        " to run this car"
      );
    },
    co2SavingsDetails() {
      let tree = this.co2Data[this.treeIndex];
      let amount = Math.ceil(this.car.CO2Savings / tree.PerTree);
      return (
        "And you would need to plant at least " +
        amount +
        " " +
        tree.Name +
        " tree" +
        (amount > 1 ? "s" : "") +
        " every year just to re-capture these emissions*"
      );
    },
    petrolCosts() {
      return (
        "$" +
        this.formatPrice(
          this.car.PetrolEquivilent -
            this.$dealer.user_settings.annualMaintenanceICE
        )
      );
    },
    runningCostsSavings() {
      return (
        "$" +
        this.formatPrice(this.car.PetrolEquivilent - this.car.RunningCosts)
      );
    },
    co2Savings() {
      return this.car.CO2Savings.toLocaleString("en");
    },

  },
  methods: {
    updateSelected(selected) {
      this.$emit("change", selected);
      this.selected = true;
    },
    triggerSettings() {
      this.$emit("show-settings");
    },
    openListings() {
      let link =
        this.car.ListingLink || this.$dealer.default_settings.listingLink;
      window.open(link, "_blank");
    },
  },
  components: {
    ContactForm,
  },
};
</script>

<style scoped>
body {
    font-family: Roboto, sans-serif;
}
.car-header {
  text-align: center;
  display: block;
  background: #eee;
  padding: 10px;
  font-family: Roboto, sans-serif;
}
.short-row {
  height: 20px;
    font-family: Roboto, sans-serif;
}
.unsuitable {
  color: red;
    font-family: Roboto, sans-serif;
}
.savings {
  color: green;
  text-align: center;
  font-size: 32px;
    font-family: Roboto, sans-serif;
}
.small {
  font-size: 0.8em;
  text-align: center;
  line-height: 1.1;
    font-family: Roboto, sans-serif;
}
.details {
  font-size: 0.75em;
  text-align: center;
  line-height: 1.1;
  margin-top: -10px;
  padding: 5px;
    font-family: Roboto, sans-serif;
}
.recommended {
  font-weight: bold;
    font-family: Roboto, sans-serif;
}
.big_plus {
  text-align: center;
  font-weight: bold;
  font-size: 2em;
  margin-top: -30px;
    font-family: Roboto, sans-serif;
}
.disclaimer {
  font-style: italic;
  text-align: center;
    font-family: Roboto, sans-serif;
}

.center {
  text-align: center;
    font-family: Roboto, sans-serif;
}

.mx-20 {
  margin-left: 80px;
  margin-right: 80px;
    font-family: Roboto, sans-serif;
}
.and {
  margin-bottom: 40px;
  position: relative;
  top: -10px;
    font-family: Roboto, sans-serif;
}

.savings-icon {
  filter: invert(21%) sepia(89%) saturate(3064%) hue-rotate(96deg)
    brightness(95%) contrast(104%);
  margin-right: 5px;
}

.v-data-table__mobile-row__cell:first-child {
  font-weight: 600 !important;
}

.v-data-table .v-data-table__mobile-row {
  min-height: 24px;
}
</style>